export const createRowErrors = (errors: number[]) =>
  errors.reduce((acc, curr, idx, arr) => `${acc} ${curr}${idx === arr.length - 1 ? '.' : ', '} `, '');
